var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.19182 6.57834C1.36085 4.08543 3.90915 1.8046 6.29505 2.90578L20.0973 9.27607C22.4211 10.3486 22.421 13.6513 20.0973 14.7238L6.29505 21.0941C3.90915 22.1952 1.36086 19.9144 2.19183 17.4215L3.68279 12.9486C3.88805 12.3328 3.88806 11.6671 3.68279 11.0513L2.19182 6.57834ZM5.87599 3.81374L19.6782 10.184C21.2274 10.899 21.2274 13.1009 19.6782 13.8159L5.87599 20.1861C4.28539 20.9202 2.58653 19.3997 3.14051 17.7377L4.63147 13.2649C4.71482 13.0148 4.77279 12.7586 4.80537 12.4999H13.999C14.2752 12.4999 14.499 12.2761 14.499 11.9999C14.499 11.7238 14.2752 11.4999 13.999 11.4999H4.80536C4.77278 11.2413 4.71482 10.9851 4.63147 10.735L3.1405 6.26212C2.58652 4.60017 4.28539 3.07962 5.87599 3.81374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.5dddc032dd467207abeb538587dd4f6f.svg";
export { ForwardRef as ReactComponent };